<template>
  <div>
    <div v-if="helpCenter" class="helpCenter-title" />
    <ul v-if="!helpCenter" class="left-nav-com">
      <li v-for="item in leftNavData" :key="item.key">
        <div
          class="flex align-items-center justify-content-space-between"
          @click.stop="openNav(item)"
        >
          <div>
            <van-icon
              v-if="item.icon"
              :name="require('@/assets/mine/' + item.icon + '.png')"
              size="24px"
            />
            {{ item.name }}
          </div>
          <div tyle="color: #333333;">
            <i class="el-icon-arrow-right" :class="{ rate: item.open }" />
          </div>
        </div>
        <ul
          class="nav-list"
          :style="{ height: item.open ? item.child.length * 50 + 'px' : '0px' }"
        >
          <li
            v-for="v in item.child"
            :key="v.key"
            :class="{ actived: tkey == v.key }"
            class="ihover"
            @click.stop="handleNav(item, v)"
          >
            {{ v.name }}
            <span v-if="v.name == '门店资质' && QualificationCount">{{
              QualificationCount > 99 ? '99+' : QualificationCount
            }}</span>
            <span v-if="v.name == '消息通知' && customerMsgCount">{{
              customerMsgCount > 99 ? '99+' : customerMsgCount
            }}</span>
          </li>
        </ul>
      </li>
    </ul>
    <ul v-else class="left-nav-com">
      <li v-for="item in leftNavHelpData" :key="item.key">
        <div>
          <van-icon
            v-if="item.icon"
            :name="require('@/assets/mine/' + item.icon + '.png')"
            size="24px"
          />
          {{ item.name }}
        </div>
        <ul>
          <li
            v-for="v in item.child"
            :key="v.key"
            :class="{ actived: tkey == v.key }"
            class="ihover"
            @click.stop="handleNav(item, v)"
          >
            {{ v.name }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { LinkTypeCode } from '../dictionary/base'
import { BaseMixin } from '../mixins/BaseMixin'

export default {
  name: 'IMineNav',
  mixins: [BaseMixin],
  props: {
    activedParentKey: {
      type: Number,
      default: 1
    },
    activedKey: {
      type: Number,
      default: 11
    },
    helpCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tkey: 11,
      pTkey: 1,
      isHead: false, // 是否总店
      leftNavData: [
        {
          name: '我的账户',
          icon: 'left-nav-wodezhanghu-icon',
          key: '1',
          open: false,
          child: [
            {
              name: '个人中心',
              url: LinkTypeCode.Mine,
              key: '11'
            },
            {
              name: '门店信息',
              url: LinkTypeCode.StoreInfo,
              key: '12'
            },
            {
              name: '门店资质',
              url: LinkTypeCode.MyQualifications,
              key: '13'
            },
            {
              name: '收货地址',
              url: LinkTypeCode.AddressShow,
              key: '14'
            },
            // 券商城
            {
              name: '券商城',
              url: LinkTypeCode.BrokerageCity,
              key: '49'
            },
            // 新品收集
            {
              name: '新品收集',
              url: LinkTypeCode.NewGoodsCollect,
              key: '50'
            },
            // 子账号管理
            {
              name: '子账号管理',
              url: LinkTypeCode.ChildAccount,
              key: '51'
            },

            {
              name: '开票信息',
              url: LinkTypeCode.ApplyInvoice,
              key: '15'
            },
            {
              name: '连锁设置',
              url: LinkTypeCode.InterlockSettings,
              key: '60'
            },
            {
              name: '药品检验报告',
              url: 'http://dy.jndym.com.cn:9200/jybg/',
              key: '17'
            },
            {
              name: '消息通知',
              url: LinkTypeCode.Msg,
              key: '16'
            },
            { name: '直播间', url: window._CONFIG['liveRoomUrl'], key: '24' }
          ]
        },
        {
          name: '交易管理',
          icon: 'left-nav-jiaoyiguanli-icon',
          key: '2',
          open: false,
          child: [
            {
              name: '我的订单',
              url: LinkTypeCode.MyOrder,
              key: '21'
            },
            {
              name: '退款/售后',
              url: LinkTypeCode.AfterSale,
              key: '23'
            },
            {
              name: '优惠券',
              url: LinkTypeCode.MyCoupon,
              key: '22'
            }
          ]
        },
        {
          name: '我的收藏',
          icon: 'left-nav-wodeshoucang-icon',
          key: '3',
          open: false,
          child: [
            {
              name: '常购清单',
              url: LinkTypeCode.AlwaysBuysList,
              key: '31'
            },
            {
              name: '收藏的商品',
              url: LinkTypeCode.MyCollection,
              key: '32'
            }
            // { name: "我的控销", url: LinkTypeCode.MyControlPin, key: "33" }
          ]
        },
        {
          name: '帮助中心',
          icon: 'left-nav-bangzhuzhongxin-icon',
          key: '4',
          open: false,
          child: [
            {
              name: '问题反馈',
              url: LinkTypeCode.Feedback,
              key: '41'
            },
            {
              name: '帮助中心',
              url: LinkTypeCode.HelpCenter,
              key: '42'
            }
            // ,
            // {
            //   name: '乱价投诉',
            //   url: LinkTypeCode.DisorderlyPrice,
            //   key: '43'
            // }
          ]
        }
      ],
      QualificationCount: 0,
      customerMsgCount: 0,
      liveRoomUrl: '',
      leftNavHelpData: [
        {
          name: '新手指南',
          icon: 'xinshouzhinan',
          key: '1',
          child: [
            {
              name: '用户注册',
              id: '151b6f48-6183-4a99-d213-08d80ea802d0',
              key: '11'
            },
            {
              name: '用户登录',
              id: '77f5fd3b-4404-4d91-5072-08d811cf9ba3',
              key: '12'
            },
            {
              name: '采购指南',
              id: '04303a48-f607-4c9e-5073-08d811cf9ba3',
              key: '13'
            },
            {
              name: '首营认证',
              id: '4e90294b-d543-4f89-5074-08d811cf9ba3',
              key: '14'
            }
          ]
        },
        {
          name: '售后服务',
          icon: 'shouhoufuwu',
          key: '2',
          child: [
            {
              name: '退款流程',
              id: '44d3d2f7-3e87-4033-5075-08d811cf9ba3',
              key: '21'
            },
            {
              name: '退货流程',
              id: '611c80e6-c09f-4dde-5076-08d811cf9ba3',
              key: '22'
            },
            {
              name: '订单开票',
              id: 'd2ddba79-7b5f-4360-5077-08d811cf9ba3',
              key: '23'
            }
          ]
        },
        {
          name: '常见问题',
          icon: 'changjianwenti',
          key: '3',
          child: [
            {
              name: '优惠券使用',
              id: 'be462f34-116d-44f1-5078-08d811cf9ba3',
              key: '31'
            },
            {
              name: '限额说明',
              id: '164e7169-71a6-45e6-5079-08d811cf9ba3',
              key: '32'
            },
            {
              name: '支付方式',
              id: '3974cfed-e52e-4896-507a-08d811cf9ba3',
              key: '33'
            },
            {
              name: '门店切换',
              id: '0c63a723-d130-48fc-507b-08d811cf9ba3',
              key: '34'
            }
          ]
        },
        {
          name: '关于我们',
          icon: 'guanyuwomen',
          key: '4',
          child: [
            {
              name: '平台介绍',
              id: '3e440c62-8c0b-49dc-507c-08d811cf9ba3',
              key: '41'
            },
            {
              name: '用户协议',
              id: '56d17744-f8c3-4793-507d-08d811cf9ba3',
              key: '42'
            }
          ]
        }
      ]
    }
  },
  watch: {
    activedParentKey: {
      handler(val) {
        if (val != this.pKey) this.pKey = val
      },
      immediate: true
    },
    activedKey: {
      handler(val) {
        if (val != this.tkey) this.tkey = val
      },
      immediate: true
    },
    '$store.state.authIsSubAccount': {
      handler(val) {
        if (val) {
          // 当前为子账号，屏蔽子账号入口
          this.leftNavData[0].child = this.leftNavData[0].child.filter(
            (item) => item.name !== '子账号管理'
          )
        }
      },
      immediate: true,
      deep: true
    }
  },

  async mounted() {
    // 获取资质统计
    this.getQualificationCount()
    // 获取未读消息
    this.getCustomerMsg()
    await this.getCustomIsControlMan()
    // 判断是否为总店
    this.judgHeadStore()
    this.getLiveRoom()
    this.openNavCheck()
  },
  methods: {
    //
    async getLiveRoom() {
      const res = await this.getAction('/api_goods/GoodsLive/GetLiveUrlData')
      if (res.IsSuccess) {
        this.liveRoomUrl = res.Data
      }
    },
    openNavCheck() {
      this.leftNavData.forEach((item) => {
        const i = item.child.findIndex((value) => value.key == this.activedKey)
        if (i > -1) {
          item.open = true
        } else {
          item.open = false
        }
      })
    },
    // 个人中心NAV展开
    openNav(item) {
      item.open = !item.open
    },
    // 获取当前用户是否为控销组成员
    async getCustomIsControlMan() {
      const res = await this.getAction(
        '/api_customers/Customer/CustomerIsControlMan'
      )
      if (res.IsSuccess && res.Data) {
        this.$store.commit('_setControlGroupMan', res.Data)
        // 追加我的控销按钮入口
        this.leftNavData[0].child.push({
          name: '我的控销',
          url: LinkTypeCode.MyControlPin,
          key: '33'
        })
      }
    },
    // 判断是否未总店
    async judgHeadStore() {
      const res = await this.getAction(
        '/api_customers/MutiCustomer/JudgHeadStore'
      )
      if (res.IsSuccess && res.Data && res.Data.Type == 1) {
        this.leftNavData[0].child = this.leftNavData[0].child.filter(
          (item) => item.name !== '连锁设置'
        )
      }
    },
    // 获取资质统计
    async getQualificationCount() {
      const res = await this.getAction(
        '/api_customers/Customer/GetAttrExpiredCount'
      )
      if (res.IsSuccess) {
        this.QualificationCount = res.Data
      } else {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
      }
    },
    // 获取未读消息
    async getCustomerMsg() {
      this.$hys.openLoading()
      const res = await this.getAction('/api_customers/CustomerMessage/List', {
        isRead: false,
        messageType: '',
        keyword: '',
        pageindex: 1,
        pagesize: 100
      })
      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
      }
      if (res.IsSuccess && res.Data) {
        this.customerMsgCount = res.Count
      }
    },
    handleNav(item, v) {
      console.log(LinkTypeCode, LinkTypeCode[v.url])
      if (this.helpCenter) {
        this.$emit('handleNav', item, v)
        return
      }
      if (v.name == '直播间') {
        window.open(this.liveRoomUrl)
      }
      if (v.url == 'MemberCenter') {
        this.$router.push({
          path: LinkTypeCode.Mine
        })
      } else if (v.name == '药品检验报告') {
        window.open(v.url)
      } else if (v.name == '开票信息') {
        this.$router.push({
          path: 'ApplyInvoice',
          query: {
            nav: 'nav'
          }
        })
      } else {
        this.$router.push({
          path: LinkTypeCode[v.url]
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
ul.left-nav-com {
  padding-bottom: 6px;
  width: 238px;

  .el-icon-arrow-right {
    transition: transform .3s;
  }

  .rate {
    transform: rotate(90deg);
  }

  > li {
    padding: 18px 0 5px;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    color: #222222;

    > div {
      position: relative;
      margin-bottom: 15px;
      padding: 0 28px 0 60px;

      /deep/ .van-icon {
        position: absolute;
        top: 38%;
        left: 28px;
        transform: translateY(-50%);
      }
    }

    .nav-list {
      overflow: hidden;
      height: 0;
      transition: height .3s;
    }

    > ul {
      > li {
        padding: 15px 28px 15px 60px;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.3;
        cursor: pointer;

        > span {
          position: relative;
          top: -10px;
          left: 4px;
          display: inline-block;
          border-radius: 10px;
          width: 28px;
          height: 19px;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: rgba(255, 57, 57, 1);
          line-height: 19px;
        }
      }

      > li.actived {
        border-left: 4px solid #0F6EE9;
        padding-left: 56px;
        background:
          linear-gradient(
            78deg,
            rgba(232, 242, 255, 1) 0%,
            rgba(255, 255, 255, 1) 100%
          );
      }
    }
  }
}

.helpCenter-title {
  width: 240px;
  height: 60px;
  font-size: 20px;
  text-align: left;
  text-indent: 30px;
  color: #FFFFFF;
  background: url('../assets/mine/help-title.png') no-repeat;
  background-size: 240px 60px;
  line-height: 60px;
}
</style>
